module.exports = __webpack_public_path__ + "img/skoda-logo.58ab6dc1.png";